<template>
  <div
    class="flex items-center bg-white clamp-rounded-11-11 clamp-min-w-40-65 justify-center shadow-card clamp-p-2-3"
  >
    <AInputText
      class="clamp-pl-2-6"
      :modelValue="modelValue"
      :searchPlaceholder="searchPlaceholder || 'Search...'"
      @keydown.enter.prevent="onEnter"
      @input="
        ($event: Event) =>
          emit('update:modelValue', ($event.target as HTMLInputElement).value)
      "
    />
    <AIconButton
      class="!color-gray shrink-0 transition-opacity duration-150"
      :class="{
        'opacity-0 pointer-events-none': !modelValue,
      }"
      icon="xmark"
      size="sm"
      ariaLabel="Clear"
      :disableHoverEffect="true"
      @click="
        ($event) => {
          emit('update:modelValue', '');
          emit('clear', $event);
        }
      "
    />
    <AButton
      v-if="submitText"
      icon="magnifying-glass"
      size="sm"
      :text="submitText"
      variant="secondary"
      @click="($event) => emit('search', $event)"
      class="shrink-0"
    />
    <AIconButton
      v-else
      icon="magnifying-glass"
      size="sm"
      ariaLabel="Search"
      variant="secondary"
      @click="($event) => emit('search', $event)"
      class="shrink-0"
    />
  </div>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    modelValue: string;
    searchPlaceholder?: string;
    size?: 'sm' | 'md';
    submitText?: string;
  }>(),
  {
    size: 'md',
  },
);
const emit = defineEmits(['update:modelValue', 'search', 'clear']);

const onEnter = (event: KeyboardEvent) => {
  (event.target as HTMLInputElement).blur();
  emit('search', event);
};
</script>
